import React from 'react'

import ContactForm from '../ContactForm'

export default function PricesContainerSection({
  title,
  description,
  formProps,
}) {
  return (
    <section
      id="prices-contact"
      data-scroll-index="5"
      className="main-section center-align"
    >
      <div className="main-section">
        <div className="container">
          {/*<!--Title-->*/}
          <h4 className="reflection-text p-b-2">{title}</h4>

          {/*<!-- Description -->*/}
          <p className="p-t-1 desc">{description}</p>

          <ContactForm {...formProps} />
        </div>
      </div>
    </section>
  )
}



// WEBPACK FOOTER //
// ./src/components/Sections/PricesContactSection.js